<script lang="ts">
	import type { CollectionEntry } from 'astro:content'
	import { format } from 'date-fns'
	import { onMount } from 'svelte'
	import { Events, mapToDb } from '~/lib/tn'
	import { addRecentlyViewed } from '~/stores/local'

	export let event: Omit<CollectionEntry<'events'>['data'], 'id'> & {
		id: number
	}
	export let id

	onMount(async () => {
		try {
			if (!event) {
				let tempEvent = await Events.get(id)
				event = mapToDb(tempEvent)
			}
			if (event) {
				addRecentlyViewed({
					title: event.event_name,
					type: 'event',
					id,
				})
			}
		} catch (error) {
			console.error(error)
		}
	})
</script>

{#if event}
	{@const { event_name, event_date, state, city, venue_id, venue_name } = event}

	<div
		class="flex w-full items-center justify-center border-b bg-white px-6 py-5 sm:justify-between"
	>
		<div class="flex items-center space-x-3">
			<!-- <div
				class="flex flex-col items-center justify-center p-3 rounded bg-white w-16 h-16 border-2 border-gray-400"
			>
				<span class="block font-bold">{format(new Date(), 'MMM')}</span>
				<span class="block">{format(new Date(), 'd')}</span>
			</div> -->
			<div class="text-center sm:text-left">
				<h1 class="text-xs font-bold sm:text-lg">{event_name}</h1>
				<p class="text-light text-xs sm:text-sm">
					{format(event_date, 'eee, MMM dd, yyyy')} - {format(
						event_date,
						'h:mm a',
					)} - {venue_name} ({city}, {state})
				</p>
			</div>
		</div>
		<!-- <div>
			{pricingInfo?.lowPrice?.text?.formatted} - {pricingInfo?.highPrice?.text?.formatted}
		</div> -->
		<div class=" hidden w-64 sm:flex">
			<p class="text-xs text-gray-400">
				We are a resale marketplace, not the ticket seller. Prices are set by
				third-party sellers and may be above or below face value.
			</p>
		</div>
	</div>
{/if}
